"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createBreakpoints = _interopRequireDefault(require("@material-ui/core/styles/createBreakpoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var breakpoints = (0, _createBreakpoints["default"])({});
breakpoints.values.sm = 600;
breakpoints.values.lg = 1440;
var _default = breakpoints;
exports["default"] = _default;